<template lang="pug">

	div.sticky.top-0.z-50(class="md:hidden")
		.relative.bg-white.border-b-2.flex.z-50
			template(v-if="loading")
				.w-2.h-2.m-05
					i.fas.fa-asterisk.fast-spin.text-lg
			template(v-else)
				.w-2.h-2.m-05(@click="navActive = !navActive" v-bind:class="{ 'bg-blue' : navActive, 'bg-red rounded-full' : !navActive }")
			.absolute.w-full.flex.justify-center.items-center.h-full.pointer-events-none {{ currentPage }}
			.ml-auto.mx-1.cartStatus.cursor-pointer.grid.grid-cols-2.gap-05.items-center(@click="toggleCart()" v-if="storeState.checkoutLoaded, cart_qty > 0") 
				span
					svg(version="1.1", xmlns="http://www.w3.org/2000/svg", xlink="http://www.w3.org/1999/xlink", x="0px", y="0px", width="13px", height="17px", viewBox="0 0 13 17", style="overflow:visible;enable-background:new 0 0 13 17;", space="preserve")
						path.st0.fill-current.text-blue(d="M11.3,4c-0.5-2.3-2.5-4-4.8-4S2.1,1.7,1.7,4H0v13h13V4H11.3z M6.5,0.9c1.9,0,3.5,1.3,3.9,3H2.6C3,2.2,4.6,0.9,6.5,0.9z")
				span {{ cart_qty }}
		ul.mobile-nav.fixed.inset-0.bg-white.z-40(v-bind:class="{ 'active' : navActive }")
			//- img.james-logo.absolute(src="../../../../public/images/james.svg", alt="James")
			.grid.grid-cols-4.gap-05.p-05.mt-auto.w-full(v-bind:class="{ 'opacity-50' : loading }")
				.col-span-1.text-blue.flex.justify-center Menu:
				template(v-if="mobileNav")
					li.col-span-3.col-start-2.border-2.border-red.text-red.flex.justify-center
						a.block.pb-2.w-full.flex.justify-center(href="/" @click="clickedNavItem()") © J4M3Z 8ROWN
					template(v-for="item in mobileNav")
						li.col-span-3.col-start-2.border-2.border-red.text-red.flex.justify-center
							a.block.pb-2.w-full.flex.justify-center(:href="item.page.url" @click="clickedNavItem()") {{ item.page.title }}
				li.col-span-2.border-2.border-red.text-red.flex.justify-center
					a.block.pb-2.w-full.flex.justify-center(href="mailto:you@jamesbrown.wtf" @click="navActive = false") Contact
				li.col-span-2.border-2.border-red.text-red.flex.justify-center
					a.block.pb-2.w-full.flex.justify-center(href="/store" @click="clickedNavItem()") Store
				li.col-span-1.border-2.border-red.text-red.flex.justify-center
					a.block.pb-2.w-full.flex.justify-center(href="https://www.instagram.com/jamesbrown.wtf" target="blank") IG
				li.col-span-1.border-2.border-red.text-red.flex.justify-center
					a.block.pb-2.w-full.flex.justify-center(:href="randomNav && randomNav[0]?.page.url" target="blank") &amp;&amp;
				li.col-span-2.bg-red.border-2.border-red.text-red.flex.justify-center
					.text-white(v-on:click="navActive = false") Close Menu
					

</template>

<script>
import { store } from "./../shopify/store.js";
let axios = require('axios').default;
let token = document.head.querySelector('meta[name="csrf-token"]');

export default {
	name: "Nav",
	data() {
		return {
			storeState: store.state,
			mobileNav: null,
			randomNav: null,
			navActive: false,
			currentPage: '8ROWN',
			loading: false
		}
	},
	computed: {
		cart_qty() {
			let total_pieces = 0;
			if (store.state.checkout) {
				store.state.checkout.lineItems.forEach(item => {
					total_pieces += item.quantity
				});
			}
			return total_pieces
		}
	},
	methods: {
		toggleCart() {
			store.state.showCart = !store.state.showCart 
		},
		clickedNavItem () {
			this.loading = true
		},
		getNav () {

			axios({
				url: '/graphql',
				method: 'post',
				headers: {
					'X-CSRF-TOKEN': token.content
				},
				data: {
					query: `
						query getNav {
							nav(handle: "mobile_nav") {
								handle
								title
								tree {
									page {
										title
										url
									}
								}
							}
						}
					`
				}
			})
			.then(response => {
				this.mobileNav = response.data.data.nav.tree
				
				// filter the tree to only include pages that have the title "&&"
				this.randomNav = this.mobileNav.filter(item => item.page.title === '&&')
				console.log('randomNav', this.randomNav)
				// now remove the randomNav from the mobileNav
				this.mobileNav = this.mobileNav.filter(item => item.page.title !== '&&')
				console.log('mobileNav', this.mobileNav)
			})
			.catch(error => {
				console.log('Something went wrong...')
			})
			.finally(() => {
				// Only run the following on initial load...
			})

		}
	},
	beforeMount() {
		this.currentPage = this.$el.attributes['data-current-page'].value
	},
	mounted: function() {
		console.log('Mounted...')
		this.getNav()
	}
}

</script>
